import { Plugin } from "@nuxt/types";
import { initializeSentry } from "../../shared/accessors/sentry";

const accessor: Plugin = ({ $sentry, $sentryReady }) => {
  initializeSentry($sentry, $sentryReady);
};

export default accessor;
